<template>
    <div>
        <navigation-bar Back Bell/>
        <div class="main BookRecord">
            <div class="no-data" v-if="!bookingData">
                <img src="@/assets/images/empty.svg">
                <p>
                    OH！目前空空的<br>
                    可以到首頁<br>
                    線上預約好店
                </p>
            </div>
            <div class="container" v-if="bookingData">
                <div class="top-info">
                    <i class="el-icon-check"/> 尚有{{bookingData.length}}筆訂位，正在進行中
                </div>
                <div v-for="(item,index) in bookingData" :key="index" class="book-list">
                    <div class="list-style">
                        <div>
                            <el-image :src= item.storeImage  class="pic2 mr-3" fit="cover"></el-image>
                            <p class="distance"><img src="@/assets/images/location_blue_line.svg">{{item.storeDistance}}公里</p>
                        </div>
                        <div class="content">
                            <h2>{{item.brandName}}<span class="ml-3">{{item.storeName}}</span></h2>
                            <a @click="$public.callTel(item.storeTel)" class="phone-btn">
                                <img src="@/assets/images/phone.svg">
                                <span>{{item.storeTel}}</span>
                            </a>
                            <a class="location-btn" @click="$public.openMap(item.lat, item.lng)">
                                <img src="@/assets/images/location_blue.svg">
                                <span>{{item.city}}{{item.township}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="d-flex record-detail">
                        <div class="red mr-3">
                            <h2>{{item.bookingTime}}</h2>
                        </div>
                        <div class="flex-grow-1">
                            <p>{{item.bookingDate}} {{getWeekName(item.bookingDate)}}</p>
                            <p>{{item.adult}}位大人 {{item.children}}位小孩</p>
                        </div>
                        <div>
                            <el-button class="small" round @click="editBooking(item)">編輯/取消</el-button>
                        </div>
                    </div>
                    <div class="shadow-line mt-2 mb-2"/>
                </div>
            </div>
        </div>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    const weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"


    export default {
        name: 'BookRecord',
        components: {
            Toast,
        },
        data() {
            return {
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                storeId: 0,
                userId: 0,
                bookingData: '',
                isLoading: false,
                confirmBookingUrl: '',
                lng: 0,
                lat: 0,
                nowEditBookData: null,
                isGoToPageBookingOpened: false, //是否已開啓過頁面？
                goToPageBookingId: 0, //預先傳進來的訂位ID，如果有傳這個ID，接着就要開啓訂位頁面，頁面只開啓一次所以不可用 query
                goToPageBookingStoreId: 0, //預先傳進來的訂位店家ID
            }
        },
        created() {
            try {
                let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (dataObject.usedType === this.$route.name) {
                    this.dataObject = dataObject
                    this.storeId = this.dataObject.storeId || 0;
                    this.userId = this.dataObject.userId || 0;
                    this.goToPageBookingId = this.dataObject.goToPageBookingId || 0;
                    this.goToPageBookingStoreId = this.dataObject.goToPageBookingStoreId || 0;
                }
            } catch (e) {
                // console.log(e)
                // console.log(this.dataToken)
            }

            //若是從個人資訊,route帶入的storeId = allStore
            if (this.storeId === "allStore") {
                this.initialId();
            }
        },
        mounted() {

            let self = this;
            if (Number(self.userId) <= 0)  {
                self.$store.commit(mutationTypes.SHOW_TOAST, "缺少必要的參數");
                return false
            }

            self.isLoading = true;
            self.getGpsLocation()
                .then(
                    self.getWhetherIsBooking
                )
                .then(
                    self.loadBookingRecord
                )
                .then(
                    () => {
                        self.isLoading = false;

                        //如果 isGoToPageBookingOpened = false且有傳入 goToPageBookingId等，才做接下來的判斷
                        if (!self.isGoToPageBookingOpened && self.goToPageBookingId > 0 && self.goToPageBookingStoreId > 0) {
                            self.isGoToPageBookingOpened = true;

                            if (self.bookingData.length > 0) {
                                let isFound = false;

                                self.bookingData.forEach(item => {
                                    if (!isFound && item.bookingId === self.goToPageBookingId) {
                                        isFound = true;
                                        self.editBooking(item);
                                    }
                                });

                                if (!isFound) {
                                    //沒有找到預訂要開啓的記錄頁面
                                    alert("目前沒有找到這筆記錄");
                                }
                            }
                        }

                    }
                )
                .catch( (error) => {
                    self.isLoading = false;
                    self.loadBookingRecord();
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });
        },
        methods: {


            initialId:function(){
                let self = this;
                let userToken = localStorage.getItem("admin_token");
                let decrypted = self.$crypto.decryptText(userToken);
                let decrypted_array = decrypted.split(';');
                self.userId = decrypted_array[0];
                self.storeId = 0;
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {

                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        //完畢
                        resolve();
                    };

                    let onError = function (error) {
                        // reject("無法定位GPS");
                        //完畢
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },


            /** 獲取使用者訂位資訊 */
            getWhetherIsBooking : function() {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetUserWhetherIsBooking${{
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.confirmBookingUrl = json.data.editbookingUrl+"/";
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },


            loadBookingRecord:function(position){

                let dataList = [];
                let self = this
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetBookingRecord${{
                        id:Number(self.userId),
                        storeId:Number(self.storeId),
                        lat: self.lat,
                        lng: self.lng,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            json.data.forEach(item => {

                                let storeImage = '';
                                let storeDistance = 0;
                                if (self.$public.notNull(item.storeimage)) {
                                    storeImage = item.storeimage;
                                }

                                if (self.$public.notNull(item.storedistance)) {
                                    storeDistance = item.storedistance.toFixed(2);
                                }

                                dataList.push({
                                    lat:item.lat,
                                    lng:item.lng,
                                    address:item.address,
                                    personCount:parseInt(item.adult)+parseInt(item.child)+parseInt(item.baby),
                                    bookingAt:item.booking_at,
                                    bookingDate:(item.booking_at).substr(0,10),
                                    bookingTime:(item.booking_at).substr(11,11).substr(0,5),
                                    brandName:item.brandname,
                                    bookingId:item.bookingid,
                                    city:item.city,
                                    storeId:item.storeid,
                                    storeName:item.name,
                                    storeTel:item.tel,
                                    township:item.township,
                                    adult:parseInt(item.adult),
                                    children:parseInt(item.child)+parseInt(item.baby),
                                    storeImage: storeImage,
                                    storeDistance: storeDistance,
                                });
                            });
                            self.bookingData = dataList;
                        }

                        //完成
                        resolve();
                    }}`;
                });
            },

            editBooking:function(item){
                let cryptoId = this.$crypto.encryptText(item.bookingId.toString())
                let secCryptoId = encodeURIComponent(cryptoId)
                //訂位成功 booking-confirm, 訂位取消 booking-cancel
                let confirmPageUrlSet = this.confirmBookingUrl + item.storeId.toString() +"/booking-confirm?id="+secCryptoId

                //暫存目前點到的訂位資料
                //原本是以訂位網站傳來的 url來分析訂位資料，但從訂位記錄頁打開訂位網頁時就不用再從 url取資料，直接暫存點選的訂位記錄來取得加入行事曆的資料
                this.nowEditBookData = item;

                // this.$public.openUrlWithCloseBtn(confirmPageUrlSet);
                // 以 http方式添加 google行事曆事件 : https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20220118T110000.000ZZ/20220118T120000.000ZZ
                this.loadBookingPage(confirmPageUrlSet);
            },

            /** 開啓訂位網頁 */
            loadBookingPage : function(urlSet) {

                let self = this;
                let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                // 注意，這一段是針對使用 InAppBrowser這個套件專用的方法
                //如果是 cordova開啓，就植入 javascript持續取得網頁網址 location.href，
                //直到轉成訂位成功的頁面，再將另一段 javascript植入加入行事曆按鈕中，發射 message給 app接收
                if (this.$public.isCordova()) {
                    //使用 _system的話會呼叫 app外部的 browser來開網頁

                    if (this.$public.notNull(appInBrowser)) {
                        let loop = null;

                        appInBrowser.addEventListener('message', function(...args) {

                            if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                let msgObj = args[0];
                                if (msgObj.type === 'message') {
                                    if (self.$public.notNull(msgObj.data) &&
                                        self.$public.notNull(msgObj.data.message)){

                                        if (msgObj.data.message.indexOf('booking-confirm') >= 0) {
                                            //加入到行事曆
                                            if (self.$public.notNull(self.nowEditBookData)) {
                                                self.onBookingCompleted(self.nowEditBookData);
                                            }
                                            appInBrowser.close();
                                            //更新記錄列表
                                            self.reloadBookingRecord();

                                        } else if (msgObj.data.message.indexOf('close') >= 0) {
                                            appInBrowser.close();

                                            //更新記錄列表
                                            self.reloadBookingRecord();
                                        }
                                    }
                                }
                            }
                        }, false);

                        //監聽 '載入完成' 事件
                        appInBrowser.addEventListener('loadstop', function(event) {
                            //取得訂位網頁左上角的'關閉'按鈕，並植入關閉的方式
                            appInBrowser.executeScript({
                                code: "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                    "const message = {message: 'close'};" +
                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));" +
                                    "},false);"
                            });

                            //setInterval，會一直取得網頁位址，直到位址內有 booking-confirm才會停止
                            loop = setInterval(function() {

                                appInBrowser.executeScript(
                                    {
                                        //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                        code: "location.href;"
                                    },
                                    function( values ) {

                                        //植入另一段 javascript
                                        if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                            values[0].indexOf('booking-confirm') >= 0) {

                                            //停止迴圈
                                            clearInterval( loop );

                                            //尋找 id爲 addCalender的元件(前端要先寫好)，植入按下按鈕要觸發的動作
                                            //按下後會傳回目前網頁位址，以 message的形式發送給 inAppBrowser套件
                                            appInBrowser.executeScript({
                                                code:
                                                    "document.getElementById('addCalender').addEventListener(\"click\",function(e){" +
                                                    "const messageObj = { message: location.href};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                    "}, false);"+
                                                    "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                                    "const message = {message: 'close'};" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({message}));" +
                                                    "},false);"
                                            });
                                        }
                                    }
                                );
                            }, 1000);

                        }, true);
                    }
                }

                // self.onBookingCompleted('https://booking-test.oinapp.com/app/39/booking-confirm?id=OKZRa5Hhec1J8j4kpptQLJpnWX4%3D&store=健康旗艦店&date=2021-11-28&time=18%3A00&result=success');
            },

            /** 訂位完成時 */
            onBookingCompleted: function (item) {
                //訂位完成後會跳到 http://xxx.xxx:8082/app/booking-confirm?id=paFW43Obqq%2BNmahwWtXCWTDyH0A%3D&store=Gottone%20%E8%94%AC%E9%A3%9F&date=2021-11-17&time=12%3A30&result=success
                let success = false;
                let date = '', storeName = '', brandName = '';
                let year = 0, month = 0, day = 0, hour = 0, minute = 0;

                //原本是以訂位網站傳來的 url來分析訂位資料，但從訂位記錄頁打開訂位網頁時就不用再從 url取資料，直接暫存點選的訂位記錄來取得加入行事曆的資料
                if (this.$public.notNull(item.bookingDate) && ( item.bookingDate !== '') &&
                    this.$public.notNull(item.bookingTime) && ( item.bookingTime !== '')){

                    brandName = item.brandName;
                    storeName = item.storeName;

                    let bookingDate = new Date(item.bookingDate);
                    year = bookingDate.getFullYear();
                    month = bookingDate.getMonth();
                    day = bookingDate.getDate();

                    let timeSplit = item.bookingTime.split(':');
                    if (this.$public.notNull(timeSplit) && timeSplit.length > 1) {
                        hour = Number(timeSplit[0]);
                        minute = Number(timeSplit[1]);
                        success = true;
                    }
                }

                if (success) {
                    //加入行事曆
                    this.$public.addCalendarEvent(this.$http.getOS(), `${brandName} ${storeName} 訂位`, year, month, day, hour, minute);

                } else {
                    alert("無法將訂位行程加入行事曆");
                }

            },

            /** 重新載入記錄 */
            reloadBookingRecord: function() {
                let self = this;
                self.isLoading = true;
                self.loadBookingRecord()
                    .then(
                        () => {
                            self.isLoading = false;
                        }
                    )
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            getWeekName: function(setDate) {
                let day = new Date(setDate);
                let getWeek = day.getDay();
                return weekArr[getWeek];
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/book.less"/>